export enum AuthorityPayment {
  REGISTER_PAYMENT_CONDITIONS_EDIT = '1.21.4',
  REGISTER_PAYMENT_CONDITIONS_DELETE = '1.21.3',
  REGISTER_PAYMENT_CONDITIONS_ADD = '1.21.2',
  REGISTER_PAYMENT_CONDITIONS_VIEW = '1.21.1',
  REGISTER_PAYMENT_REGISTRATION = '1.21',
}
